// extracted by mini-css-extract-plugin
export default {"inputWrapper":"MonthInput_inputWrapper__ylZVd","label":"MonthInput_label__5KhR4","leftArrowBtn":"MonthInput_leftArrowBtn__v+akx","rightArrowBtn":"MonthInput_rightArrowBtn__nrvh0"};